import * as React from 'react';
import { useSelector } from 'react-redux';
import { Aside } from '../../components/Aside';
import { Main } from '../../components/Main';
import { Page } from '../../components/Page';
import { Title } from '../../components/Title';
import { MainGalleryContainer } from '../MainGalleryContainer';
import { selectProjectTitle } from '../../selectors/project';
import { FactoidsContainer } from '../FactoidsContainer';
import { DescriptionContainer } from '../DescriptionContainer';
import { FeaturesContainer } from '../FeaturesContainer';
import { SidebarPriceContainer } from '../SidebarPriceContainer';
import { Sticky } from '../../components/Sticky';
import { BuilderInfoContainer } from '../BuilderInfoContainer';
import { AuthorInfoContainer } from '../AuthorInfoContainer';
import { ConfigurationsContainer } from '../ConfigurationsContainer';
import { OpenVillageBannerContainer } from '../OpenVillageBannerContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { SidebarBlock } from '../../components/SidebarBlock';
import { TourSectionContainer } from '../TourSectionContainer';
import { OtherProjectsContainer } from '../OtherProjectsContainer';
import { BuilderReviewsContainer } from '../BuilderReviewsContainer';
import { AccreditationBanksContainer } from '../AccreditationBanksContainer';
import { ReliableBlockContainer } from '../ReliableBlockContainer';
import { EscrowBlockContainer } from '../EscrowBlockContainer';
import { useUxfbVisitedProjectsUpdater } from '../../hooks';
import { MortgageCalculatorContainer } from '../MortgageCalculatorContainer';

export const PageContainer = () => {
  const title = useSelector(selectProjectTitle);

  useUxfbVisitedProjectsUpdater();

  return (
    <>
      <Page>
        <BreadcrumbsContainer />
        <Main>
          <Title>{title}</Title>
          <MainGalleryContainer />
          <FactoidsContainer />
          <DescriptionContainer />
          <OpenVillageBannerContainer />
          <FeaturesContainer />
          <TourSectionContainer />
          <ConfigurationsContainer />
          <AuthorInfoContainer />
          <ReliableBlockContainer />
          <BuilderReviewsContainer />
          <AccreditationBanksContainer />
          <EscrowBlockContainer />
          <MortgageCalculatorContainer />
        </Main>
        <Aside>
          <Sticky>
            <SidebarBlock>
              <SidebarPriceContainer />
            </SidebarBlock>
            <SidebarBlock>
              <BuilderInfoContainer />
            </SidebarBlock>
          </Sticky>
        </Aside>
      </Page>
      <OtherProjectsContainer />
    </>
  );
};
